<template>
  <div class="body">
	  <Headtow  @sou="sou"></Headtow>
      <Headthree></Headthree>

      <div id="w-center">
        <div class="h-30"></div>
        <!-- 左侧 -->
        <div class="w-products">
          <div id="products_type">
            <div class="Jobs_top_left">
              <p class="Jobs_jzxz">[进站须知]{{info.jzxz}}</p>
              <p class="Jobs_gly">管理员：{{info.gly}}</p>
            </div>
            <div class="head-center-right Jobs_center-right">
                <el-input placeholder="请输入您想要了解帖子" v-model="keyword">
                  <!-- <template slot="prepend">产品库</template> -->
                  <el-button slot="append" @click='jobkeyword'>搜索</el-button>
                </el-input>
            </div>
            <div class="clear"></div>
          </div>
          <div class="h-20"></div>
          <div class="Jobs_type">
            <el-radio-group v-model="tabPosition" @change="type" size="medium">
              <el-radio-button label="1" >全部</el-radio-button>
              <el-radio-button  v-for="(item, index) in types" :label="item.id" :key="item.id">{{item.title}}</el-radio-button>
            </el-radio-group>
            <el-button type="primary" icon="el-icon-plus" size="medium" class="Jobs_add_but"   @click="dialogFormVisible = true">发布</el-button>
          </div>
          <div class="h-20"></div>
          <div id="products_type">
            <ul id="Jobs-content" v-loading="loading">
               <li v-for="(item, index) in list" :key="item.id">
                  <router-link  :to="{ path: '/JobsCont',query: {id: item.id}}">
                    <div class="Jobs_div1">
                      <img :src="item.headimgurl" alt=""  v-if="item.headimgurl">
                      <img src="../../static/img/index-touxiang.png" alt="" v-else >
                    </div>
                    <div class="Jobs_div2"><img src="../../static/img/jobs_xt.jpg" alt=""></div>
                    <div class="Jobs_div3">
                      <p class="Jobs_div3_p1">
                        <span class="bj" v-if="item.user_rank == 1">{{item.text}}</span>
                        <span class="bj" v-else-if="item.user_rank == '2'" style="background: #53d194;">{{item.text}}</span>
                        <span class="bj" v-else="item.user_rank == '3'" style="background: #6c88ff;">{{item.text}}</span>
                        {{item.title}}
                      </p>
                      <p class="Jobs_div3_p2 ov1">{{item.content}}</p>
                      <p class="Jobs_div3_p3"><span>{{item.username}}&nbsp;&nbsp;&nbsp;&nbsp;发表于：{{item.create_time}}</span><span><i class="el-icon-chat-line-square">&nbsp;{{item.count}}</i></span></p>
                    </div>
                    <div class="clear"></div>
                  </router-link>
              </li>
            </ul>
            <div class="page">
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="12"
                @current-change="handleCurrentChange"
                :total="total">
              </el-pagination>
            </div>
          </div>


        </div>
        <!-- 左侧结束 -->
        <!-- 右侧开始 -->
        <UserRight></UserRight>
        <!-- 右侧结束 -->

        <el-dialog title="发布论坛" :visible.sync="dialogFormVisible">
            <!-- <Productzx  ></Productzx> -->
            <JobsFaubu @handleClose="handleClose"></JobsFaubu>
        </el-dialog>

      </div>
      <div class="clear h-30"></div>
      <Foot></Foot>
  </div>

</template>

<script>
import headthree from '@/components/public/headthree.vue';
import foot from '@/components/public/foot.vue'
import userRight from '@/components/public/userRight.vue'
import jobsFaubu from '@/components/public/jobsFaubu.vue'
import headtow from '@/components/public/headtow.vue'

export default{
  data(){
    return {
      loading:true,
      info:[],
      tabPosition:'1',
      dialogFormVisible:false,
      types:[],
      list:[],
      typeid:1,
      keyword:'',
      page:1,
      total:0,
    }
  },
  components: {
    'Headthree': headthree,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'UserRight': userRight,
    'JobsFaubu': jobsFaubu,
    'Headtow': headtow,
  },
  mounted () {
      this.recordapi();
  },
  methods:{

    

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Products/Jobslist",{'userid':userid,'type':that.typeid,'page':this.page,'keyword':this.keyword}).then(res => {
          console.log(res);
          that.info= res.info;
          that.types= res.type;
          that.list= res.list.data;
          this.total = res.list.total
          this.loading = false
        });
    },
    sou(){
     this.keywords = this.$route.query.keyword
     console.log(this.keywords);
      this.recordapi();
    },
    handleClose(){
      this.dialogFormVisible = false
      this.recordapi();
    },
    // 分类
    type:function(e){
      this.loading = true,
      console.log(e);
      this.typeid = e;
      this.keyword = '';
      this.recordapi();
    },
    // 搜索
    jobkeyword(){
      if(this.keyword==''){
        this.$message.error('请输入您要了解的帖子');
        return
      }
      this.loading = true
      this.keyword = this.keyword;
      this.recordapi();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Jobs.vue